export enum EditorBlotsEnum {
  TEXT = 'текст',
  DATE = 'дата',
  NUMBER = 'число',
  USER = 'пользователь',
  LINK = 'ссылка'
}
